<template>
  <section
    class="content-container w-full max-w-[1440px] mx-auto px-4 md:px-6 xl:px-[72px] min-[1440px]:px-[182px] overflow-x-clip"
    :class="maxWidthClass"
  >
    <slot />
  </section>
</template>

<script setup lang="ts">
const { maxWidth } = defineProps({
  maxWidth: {
    type: String,
    default: 'max-w-(--custom-max-width)',
  },
});

const maxWidthClass = computed(() => {
  return maxWidth === 'none' ? 'max-w-none' : maxWidth;
});
</script>
